// fechas.js
// Las fechas del backend vienen como 'YYYY-MM-DD' (sin hora). `new Date('2026-11-23')`
// las interpreta como medianoche UTC, que en Chile cae el día anterior.
// Estas funciones las tratan como fecha local para mostrar el día correcto.

const SOLO_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Convierte 'YYYY-MM-DD' (o ISO con hora) a Date local sin desfase de zona horaria. */
export const parseFechaLocal = (valor) => {
  if (!valor) return null;
  if (valor instanceof Date) return valor;
  const m = SOLO_FECHA.exec(String(valor).slice(0, 10));
  if (m && String(valor).length <= 10) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const formatFechaLarga = (valor) => {
  const d = parseFechaLocal(valor);
  return d ? d.toLocaleDateString('es-CL', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
};

const MESES_CORTOS = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

/** { dia: '23', mes: 'NOV', anio: 2026 } */
export const partesFecha = (valor) => {
  const d = parseFechaLocal(valor);
  if (!d) return { dia: '—', mes: '', anio: '' };
  return { dia: String(d.getDate()), mes: MESES_CORTOS[d.getMonth()], anio: d.getFullYear() };
};
